import React, { useEffect, useState } from "react";

import axios from "axios";

import { Button, Input, message, Skeleton } from "antd";

import Countdown from "react-countdown";

import Cookies from "js-cookie";

import styles from "./add-comment.module.css";

const RATE_BUTTONS = [
  { id: 3, title: "عالی" },
  { id: 2, title: "معمولی" },
  { id: 1, title: "ضعیف" },
];

function AddComment(props) {
  const params = props.match.params;

  const [doctorName, serDoctorName] = useState("");
  const [loading, setLoading] = useState(false);

  // COMMENT_FORM, ENTER_MOBILE, VERIFY_OTP, SUCCESS_MESSAGE, ERROR_OCCURRED
  const [step, setStep] = useState(null);

  const [text, setText] = useState("");
  const [rate, setRate] = useState(null);

  const [isSubmittingComment, setSubmittingComment] = useState(false);

  const [timer, setTimer] = useState(null);

  const [mobile, setMobile] = useState("");
  const [OTP, setOTP] = useState("");

  const [isGettingOTP, setGettingOTP] = useState(false);
  const [isVerifyingOTP, setVerifyingOTP] = useState(false);

  const getDoctorName = async () => {
    const formData = new FormData();

    formData.set("dr_id", params.d_id);

    setLoading(true);

    try {
      const response = await axios({
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        url: `${window.server}/doctor/name`,
        data: formData,
      });

      serDoctorName(response.data.name);
      setStep("COMMENT_FORM");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDoctorName();
  }, []);

  const handleSubmitComment = async () => {
    const token = Cookies.get("nuserRemember");

    if (!token) {
      setStep("ENTER_MOBILE");
      return;
    }

    if (text.trim().length === 0) return;
    if (!rate) return;

    const formData = new FormData();

    formData.set("token", token);
    formData.set("doctor_id", params.d_id);
    formData.set("comment", text);
    formData.set("score", rate);

    setSubmittingComment(true);

    try {
      const response = await axios({
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        url: `${window.server}/nuser/comments/store`,
        data: formData,
      });

      setStep("SUCCESS_MESSAGE");
      setTimeout(() => {
        closeAction();
      }, 3000);
    } catch (error) {
      // const statusCode = error.response.status;
      // if (statusCode === 404) {
      //   setStep("ENTER_MOBILE");
      // }

      setStep("ERROR_OCCURRED");
    } finally {
      setSubmittingComment(false);
    }
  };

  const handleGetOTP = async () => {
    if (mobile.trim().length === 0) {
      message.error("لطفا شماره همراه خود را وارد نمایید.");
      return;
    }

    const formData = new FormData();

    formData.set("mobile", mobile);
    formData.set("comment", true); // just to specify, this login process is for submitting comment

    setGettingOTP(true);

    try {
      const response = await axios({
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        url: `${window.server}/patient/login/phone`,
        data: formData,
      });

      setTimer(Date.now() + 59000); // 59 seconds

      setStep("VERIFY_OTP");
    } catch (error) {
    } finally {
      setGettingOTP(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (OTP.trim().length === 0) {
      message.error("لطفا کد پیامک شده را وارد نمایید.");
      return;
    }

    const formData = new FormData();

    formData.set("mobile", mobile);
    formData.set("code", OTP);

    setVerifyingOTP(true);

    try {
      const response = await axios({
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        url: `${window.server}/patient/login/verify`,
        data: formData,
      });

      const { type, token, type_hash } = response.data;

      // delete cookies
      Cookies.remove("topbar_v1", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
      });

      Cookies.remove("nuserRemember", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
      });

      Cookies.remove("rememberLastDrLog2", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
      });

      Cookies.remove("rememberSecretaryDrLog2", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
      });

      // set nuserRemember
      Cookies.set("nuserRemember", token, {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
        expires: 356,
      });

      switch (type) {
        case "doctor":
          Cookies.set("rememberLastDrLog2", type_hash, {
            domain: process.env.REACT_APP_COOKIE_DOMAIN,
            path: "/",
            expires: 356,
          });

          break;

        case "secretary":
          Cookies.set("rememberSecretaryDrLog2", type_hash, {
            domain: process.env.REACT_APP_COOKIE_DOMAIN,
            path: "/",
            expires: 356,
          });

          break;
      }

      handleSubmitComment();
    } catch (error) {
      message.error(
        error.response ? error.response.data.message : "مشکلی رخ داد.",
      );
    } finally {
      setVerifyingOTP(false);
    }
  };

  const closeAction = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };

  const resendOTP = ({ completed, seconds }) => {
    return (
      <Button
        type="primary"
        disabled={!completed}
        style={{
          pointerEvents: isGettingOTP || !completed ? "none" : "all",
        }}
        data-role="resend-otp"
        onClick={handleGetOTP}
      >
        {completed ? "ارسال مجدد کد" : `${seconds} ثانیه تا درخواست مجدد کد`}
      </Button>
    );
  };

  return (
    <div className={styles.main}>
      <span className={styles.title}>ثبت نظر برای پزشک</span>

      {loading && <Skeleton active />}

      {step === "COMMENT_FORM" && (
        <div className={styles.form_container}>
          <div style={{ display: "grid", gap: "0.5rem" }}>
            <span>لطفا نظر خود را در خصوص "{doctorName}" بیان نمایید.</span>
            <span>
              نظر شما به سلامت افراد دیگر ارتباط دارد. لطفا با دقت، نظر خود را
              ثبت نمایید.
            </span>

            <Input.TextArea
              rows={5}
              value={text}
              onChange={(event) => setText(event.target.value)}
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "0.5rem",
            }}
          >
            {RATE_BUTTONS.map((button) => {
              const isSelected = button.id === rate;

              return (
                <Button
                  key={button.id}
                  className={styles.rate_button}
                  onClick={() => setRate(button.id)}
                >
                  {button.title} {isSelected ? "✔️" : ""}
                </Button>
              );
            })}
          </div>

          <Button
            type="primary"
            style={{ pointerEvents: isSubmittingComment ? "none" : "all" }}
            data-role="submit-button"
            onClick={handleSubmitComment}
          >
            {isSubmittingComment ? "در حال ثبت نظر" : "ثبت نظر"}
          </Button>
        </div>
      )}

      {step === "ENTER_MOBILE" && (
        <div className={styles.login_container}>
          <div style={{ display: "grid", gap: "0.5rem" }}>
            <span>لطفا شماره همراه خود را وارد نمایید.</span>

            <Input
              inputMode="numeric"
              maxLength={11}
              placeholder="09123456789"
              value={mobile}
              onChange={(event) => setMobile(event.target.value)}
            />
          </div>

          <Button
            type="primary"
            style={{ pointerEvents: isGettingOTP ? "none" : "all" }}
            data-role="submit-button"
            onClick={handleGetOTP}
          >
            {isGettingOTP ? "در حال ارسال کد تایید" : "دریافت کد تایید"}
          </Button>
        </div>
      )}

      {step === "VERIFY_OTP" && (
        <div className={styles.login_container}>
          <div style={{ display: "grid", gap: "0.5rem" }}>
            <span>
              لطفا کد پیامک شده به شماره همراه {mobile} را وارد نمایید.
            </span>

            <Input
              inputMode="numeric"
              maxLength={4}
              value={OTP}
              onChange={(event) => setOTP(event.target.value)}
            />
          </div>

          <div style={{ display: "grid", gap: "0.5rem" }}>
            {timer !== null && (
              <Countdown key={timer} date={timer} renderer={resendOTP} />
            )}

            <Button
              type="primary"
              style={{
                pointerEvents:
                  isVerifyingOTP || isSubmittingComment ? "none" : "all",
              }}
              data-role="submit-button"
              onClick={handleVerifyOTP}
            >
              {isVerifyingOTP || isSubmittingComment
                ? "در حال ثبت نظر"
                : "بررسی و ثبت نظر"}
            </Button>
          </div>
        </div>
      )}

      {step === "SUCCESS_MESSAGE" && (
        <div className={`${styles.message} ${styles.success}`}>
          <p>نظر شما با موفقیت ثبت شد.</p>
        </div>
      )}

      {step === "ERROR_OCCURRED" && (
        <div className={`${styles.message} ${styles.error}`}>
          <p>مشکلی در فرایند ثبت نظر رخ داد.</p>
        </div>
      )}

      <button className={styles.back_btn} onClick={() => closeAction()}>
        بازگشت
      </button>
    </div>
  );
}

export default AddComment;
